import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from '@material-ui/core';
import { toast } from 'react-toastify';

import { getWorkoutById, deleteWorkout } from '~/api';

import Menu from '~/components/Menu';

import EditWorkoutDialog from './EditWorkoutDialog';

export default function EditMenuTrainingRoutineDetails({
  anchorEl,
  setAnchorEl,
  isOpen,
  workoutId,
  refreshWorkouts,
}) {
  const [editDialogIsOpen, setEditDialogIsOpen] = useState(false);
  const [workoutToEdit, setWorkoutToEdit] = useState(null);

  const getWorkout = async () => {
    const { data: workout } = await getWorkoutById(workoutId);
    setWorkoutToEdit(workout);
  };

  useEffect(() => {
    if (isOpen) {
      getWorkout();
    }
  }, [isOpen]);

  const handleDeleteWorkout = async () => {
    try {
      await deleteWorkout(workoutId);
      toast.success('Ficha deletado com sucesso !');

      refreshWorkouts();
    } catch {
      toast.error('Ops, não foi possivel deletar esta ficha!');
    }
  };

  const handleCloseMenu = () => setAnchorEl(null);

  return (
    <>
      <Menu
        id="edit-menu-workout"
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleCloseMenu}
        onClick={handleCloseMenu}
      >
        <MenuItem onClick={() => setEditDialogIsOpen(true)}>
          Editar Dados
        </MenuItem>
        <MenuItem onClick={handleDeleteWorkout}>Deletar Ficha</MenuItem>
      </Menu>

      {workoutToEdit ? (
        <EditWorkoutDialog
          isOpen={editDialogIsOpen}
          setIsOpen={setEditDialogIsOpen}
          workout={workoutToEdit}
          refreshWorkouts={refreshWorkouts}
        />
      ) : null}
    </>
  );
}

EditMenuTrainingRoutineDetails.propTypes = {
  anchorEl: PropTypes.bool.isRequired,
  setAnchorEl: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  workoutId: PropTypes.number.isRequired,
  refreshWorkouts: PropTypes.func.isRequired,
};
